import { IReduxState } from 'types/redux';

export const devicesStateSelector = (state: IReduxState) => state.devices;

export const devicesStatesMapSelector = (state: IReduxState) => state.deviceStates.map;

export const devicesListSelector = (state: IReduxState) => state.devices.list;

export const devicesStatusesSelector = (state: IReduxState) => state.deviceStatuses.map;
